<script lang="ts">
  import { onMount } from 'svelte';
  import { api } from './lib/api';
  import { isAuthenticated, authToken, adminUser, addNotification } from './lib/store';
  import { persistAuth, clearAuth, hydrateAuth } from './lib/auth';
  let email = $state('');
  let password = $state('');
  let loggingIn = $state(false);
  let showAdmin = $state(false);
  let activeTab = $state('dashboard');
  // Nuevas tabs
  let activeTabGiveaways = $state(false);
  let activeTabRewards = $state(false);
  let activeTabNotifications = $state(false);
  // Datos para las nuevas tabs
  let giveaways: any[] = $state([]);
  let rewards: any[] = $state([]);
  let customerNotifications: any[] = $state([]);
  // Datos base (productos, servicios, galería, categorías, FAQ, config)
  let products: any[] = $state([]);
  let services: any[] = $state([]);
  let gallery: any[] = $state([]);
  let categories: any[] = $state([]);
  let faqs: any[] = $state([]);
  let configItems: any[] = $state([]);
  // Mostrar formularios
  let showGiveawayModal = $state(false);
  let showRewardModal = $state(false);
  let showNotificationModal = $state(false);
  // Estados de edición para las nuevas tabs
  let editingGiveawayId: string | null = $state(null);
  let editingRewardId: string | null = $state(null);
  let showRewardCreateModal = $state(false);
  let rewardForm: any = $state({ name: '', description: '', cost: '', stock_quantity: '', is_active: true });
  let giveawayForm: any = $state({ title: '', description: '', prize: '', entry_type: 'any', requires_email: false, requires_phone: false, requires_telegram: false, start_date: '2026-11-01', end_date: '2026-12-01', max_participants: '', max_winner_entries: '1', num_winners: '1', status: 'draft' });
  let notificationForm: any = $state({ customer_ids: '', type: 'system', title: '', message: '' });
  // --- Estados de edición existentes ---
  let showProductModal = $state(false);
  let showServiceModal = $state(false);
  let showCategoryModal = $state(false);
  let showFAQModal = $state(false);
  let showGalleryModal = $state(false);
  let showConfigModal = $state(false);
  let editingProductId: string | null = $state(null);
  let editingServiceId: string | null = $state(null);
  let editingCategoryId: string | null = $state(null);
  let editingFAQId: string | null = $state(null);
  let editingGalleryId: string | null = $state(null);
  let editingConfigId: string | null = $state(null);
  let productForm: any = $state({ name: '', slug: '', brand: '', model: '', description: '', price: '', currency: 'USD', stock_quantity: '', stock_status: 'in_stock', is_featured: false, is_active: true, sort_order: '0' });
  let serviceForm: any = $state({ name: '', slug: '', description: '', scope: '', price: '', price_type: 'quote', duration_minutes: '', is_active: true, sort_order: '0' });
  let categoryForm: any = $state({ name: '', slug: '', description: '', is_active: true, sort_order: '0' });
  let faqForm: any = $state({ question: '', answer: '', category_id: '', is_active: true, sort_order: '0' });
  let galleryForm: any = $state({ title: '', description: '', url: '', category: '', is_active: true, sort_order: '0' });
  let configForm: any = $state({ key: '', value: '', description: '' });
  let deletingType: 'product' | 'service' | 'category' | 'faq' | 'gallery' | 'config' | 'giveaway' | 'reward' | null = $state(null);
  let deletingId: string | null = $state(null);

  function getToken(): string | null {
    let token: string | null = null;
    authToken.subscribe((v) => { token = v; })();
    return token;
  }

  async function login(e?: Event) {
    if (e) e.preventDefault();
    loggingIn = true;
    try {
      const res = await api.login({ email, password });
      authToken.set(res.token);
      adminUser.set(res.user);
      isAuthenticated.set(true);
      persistAuth(res.token, res.user);
      password = '';
      showAdmin = true;
      await loadAll();
      addNotification('success', 'Sesión iniciada correctamente');
    } catch (e: any) {
      clearAuth();
      authToken.set(null);
      adminUser.set(null);
      isAuthenticated.set(false);
      showAdmin = false;
      addNotification('error', e.message || 'Error al iniciar sesión');
    } finally {
      loggingIn = false;
    }
  }

  function logout() {
    showAdmin = false;
    activeTab = 'dashboard';
    clearAuth();
    isAuthenticated.set(false);
    authToken.set(null);
    adminUser.set(null);
  }
  async function loadProducts(token: string) {
    try {
      const res = await api.getAdminProducts(token);
      products = res.products ?? [];
    } catch (e: any) { console.error(e); if (e?.message === 'No autorizado') { clearAuth(); authToken.set(null); adminUser.set(null); isAuthenticated.set(false); showAdmin = false; } }
  }
  async function loadServices(token: string) {
    try {
      const res = await api.getAdminServices(token);
      services = res.services ?? [];
    } catch (e: any) { console.error(e); if (e?.message === 'No autorizado') { clearAuth(); authToken.set(null); adminUser.set(null); isAuthenticated.set(false); showAdmin = false; } }
  }
  async function loadCategories(token: string) {
    try {
      const res = await api.getAdminCategories(token);
      categories = res.categories ?? [];
    } catch (e: any) { console.error(e); if (e?.message === 'No autorizado') { clearAuth(); authToken.set(null); adminUser.set(null); isAuthenticated.set(false); showAdmin = false; } }
  }
  async function loadFAQ(token: string) {
    try {
      const res = await api.getAdminFAQ(token);
      faqs = res.faqs ?? [];
    } catch (e: any) { console.error(e); if (e?.message === 'No autorizado') { clearAuth(); authToken.set(null); adminUser.set(null); isAuthenticated.set(false); showAdmin = false; } }
  }
  async function loadGallery(token: string) {
    try {
      const res = await api.getAdminGallery(token);
      gallery = res.gallery ?? [];
    } catch (e: any) { console.error(e); if (e?.message === 'No autorizado') { clearAuth(); authToken.set(null); adminUser.set(null); isAuthenticated.set(false); showAdmin = false; } }
  }
  async function loadConfig(token: string) {
    try {
      const res = await api.getAdminAssistantConfig(token);
      configItems = res.config ?? [];
    } catch (e: any) { console.error(e); if (e?.message === 'No autorizado') { clearAuth(); authToken.set(null); adminUser.set(null); isAuthenticated.set(false); showAdmin = false; } }
  }
  async function loadAll() {
    const token = getToken();
    if (!token) return;
    await Promise.all([loadProducts(token), loadServices(token), loadCategories(token), loadFAQ(token), loadGallery(token), loadConfig(token)]);
    await Promise.all([refreshGiveaways(), refreshRewards(), refreshCustomerNotifications()]);
  }

  async function refreshGiveaways() {
    const token = getToken();
    if (!token) return;
    try {
      const res = await api.getGiveaways(token);
      giveaways = res.giveaways ?? [];
    } catch (e: any) { console.error(e); if (e?.message === 'No autorizado') { clearAuth(); authToken.set(null); adminUser.set(null); isAuthenticated.set(false); showAdmin = false; } }
  }

  async function refreshRewards() {
    try {
      const res = await api.getRewards();
      rewards = res.rewards ?? [];
    } catch (e: any) { console.error(e); if (e?.message === 'No autorizado') { clearAuth(); authToken.set(null); adminUser.set(null); isAuthenticated.set(false); showAdmin = false; } }
  }

  async function refreshCustomerNotifications() {
    const token = getToken();
    if (!token) return;
    try {
      const res = await api.getAdminNotifications(token);
      customerNotifications = res.notifications ?? [];
    } catch (e: any) { console.error(e); if (e?.message === 'No autorizado') { clearAuth(); authToken.set(null); adminUser.set(null); isAuthenticated.set(false); showAdmin = false; } }
  }

  onMount(() => {
    const hydrated = hydrateAuth();
    if (hydrated) {
      showAdmin = true;
      loadAll().catch(() => {
        clearAuth();
        authToken.set(null);
        adminUser.set(null);
        isAuthenticated.set(false);
        showAdmin = false;
      });
    } else {
      showAdmin = false;
    }
  });
  async function saveProduct() {
    const token = getToken();
    if (!token) return;
    try {
      if (editingProductId) {
        await api.updateAdminProduct(token, editingProductId, productForm);
        addNotification('success', 'Producto actualizado');
      } else {
        await api.createAdminProduct(token, productForm);
        addNotification('success', 'Producto creado');
      }
      closeProductModal();
      await loadProducts(token);
    } catch (e: any) { addNotification('error', e.message || 'Error guardando producto'); }
  }
  async function saveService() {
    const token = getToken();
    if (!token) return;
    try {
      if (editingServiceId) {
        await api.updateAdminService(token, editingServiceId, serviceForm);
        addNotification('success', 'Servicio actualizado');
      } else {
        await api.createAdminService(token, serviceForm);
        addNotification('success', 'Servicio creado');
      }
      closeServiceModal();
      await loadServices(token);
    } catch (e: any) { addNotification('error', e.message || 'Error guardando servicio'); }
  }
  async function saveCategory() {
    const token = getToken();
    if (!token) return;
    try {
      if (editingCategoryId) {
        await api.updateAdminCategory(token, editingCategoryId, categoryForm);
        addNotification('success', 'Categoría actualizada');
      } else {
        await api.createAdminCategory(token, categoryForm);
        addNotification('success', 'Categoría creada');
      }
      closeCategoryModal();
      await loadCategories(token);
    } catch (e: any) { addNotification('error', e.message || 'Error guardando categoría'); }
  }
  async function saveFAQ() {
    const token = getToken();
    if (!token) return;
    try {
      if (editingFAQId) {
        await api.updateAdminFAQ(token, editingFAQId, faqForm);
        addNotification('success', 'FAQ actualizada');
      } else {
        await api.createAdminFAQ(token, faqForm);
        addNotification('success', 'FAQ creada');
      }
      closeFAQModal();
      await loadFAQ(token);
    } catch (e: any) { addNotification('error', e.message || 'Error guardando FAQ'); }
  }
  async function saveGallery() {
    const token = getToken();
    if (!token) return;
    try {
      if (editingGalleryId) {
        addNotification('info', 'Edición de galería: usa eliminar + crear');
      } else {
        await api.createAdminGalleryImage(token, galleryForm);
        addNotification('success', 'Imagen de galería agregada');
      }
      closeGalleryModal();
      await loadGallery(token);
    } catch (e: any) { addNotification('error', e.message || 'Error guardando imagen'); }
  }
  async function saveConfig() {
    const token = getToken();
    if (!token) return;
    try {
      if (editingConfigId) {
        addNotification('info', 'Edición de config: usa eliminar + crear');
      } else {
        await api.createAdminAssistantConfig(token, configForm);
        addNotification('success', 'Configuración guardada');
      }
      closeConfigModal();
      await loadConfig(token);
    } catch (e: any) { addNotification('error', e.message || 'Error guardando configuración'); }
  }
  function confirmDelete(type: 'product' | 'service' | 'category' | 'faq' | 'gallery' | 'config' | 'giveaway' | 'reward', id: string) {
    deletingType = type;
    deletingId = id;
  }
  async function executeDelete() {
    const token = getToken();
    if (!token || !deletingType || !deletingId) return;
    try {
      switch (deletingType) {
        case 'product': await api.deleteAdminProduct(token, deletingId); break;
        case 'service': await api.deleteAdminService(token, deletingId); break;
        case 'category': await api.deleteAdminCategory(token, deletingId); break;
        case 'faq': await api.deleteAdminFAQ(token, deletingId); break;
        case 'gallery': await api.deleteAdminGalleryImage(token, deletingId); break;
        case 'config': break;
        case 'giveaway': await api.deleteGiveaway(token, deletingId); break;
        case 'reward': await api.deleteReward(token, deletingId); break;
      }
      addNotification('success', 'Elemento eliminado');
      await loadAll();
    } catch (e: any) { addNotification('error', e.message || 'Error eliminando'); }
    deletingType = null;
    deletingId = null;
  }
  function openProductModal(item?: any) {
    editingProductId = item?.id ?? null;
    productForm = item ? { ...item } : { name: '', slug: '', brand: '', model: '', description: '', price: '', currency: 'USD', stock_quantity: '', stock_status: 'in_stock', is_featured: false, is_active: true, sort_order: '0' };
    showProductModal = true;
  }
  function closeProductModal() { showProductModal = false; editingProductId = null; }
  function toggleGiveawaysTab() { activeTabGiveaways = !activeTabGiveaways; activeTab = activeTabGiveaways ? 'giveaways' : 'dashboard'; }
  function toggleRewardsTab() { activeTabRewards = !activeTabRewards; activeTab = activeTabRewards ? 'rewards' : 'dashboard'; }
  function toggleNotificationsTab() { activeTabNotifications = !activeTabNotifications; activeTab = activeTabNotifications ? 'notifications' : 'dashboard'; }

  async function saveReward() {
    const token = getToken();
    if (!token) return;
    if (editingRewardId) {
      await api.updateReward(token, editingRewardId, { ...rewardForm, cost: Number(rewardForm.cost), stock_quantity: rewardForm.stock_quantity ? Number(rewardForm.stock_quantity) : null });
      addNotification('success', 'Recompensa actualizada');
    } else {
      await api.createReward(token, { ...rewardForm, cost: Number(rewardForm.cost), stock_quantity: rewardForm.stock_quantity ? Number(rewardForm.stock_quantity) : null });
      addNotification('success', 'Recompensa creada');
    }
    closeRewardModal();
    await refreshRewards();
  }

  function openRewardModal(item?: any) {
    editingRewardId = item?.id ?? null;
    if (item) {
      rewardForm = { name: item.name, description: item.description || '', cost: String(item.cost), stock_quantity: item.stock_quantity ? String(item.stock_quantity) : '', is_active: item.is_active };
    } else {
      rewardForm = { name: '', description: '', cost: '', stock_quantity: '', is_active: true };
    }
    showRewardModal = true;
  }

  function closeRewardModal() { showRewardModal = false; editingRewardId = null; }

  async function saveGiveaway() {
    const token = getToken();
    if (!token) return;
    if (editingGiveawayId) {
      await api.updateGiveaway(token, editingGiveawayId, giveawayForm);
      addNotification('success', 'Sorteo actualizado');
    } else {
      await api.createGiveaway(token, giveawayForm);
      addNotification('success', 'Sorteo creado');
    }
    closeGiveawayModal();
    await refreshGiveaways();
  }

  function openGiveawayModal(item?: any) {
    editingGiveawayId = item?.id ?? null;
    if (item) {
      giveawayForm = { ...item, start_date: item.start_date?.split('T')[0] || '2026-11-01', end_date: item.end_date?.split('T')[0] || '2026-12-01', max_participants: item.max_participants?.toString() || '' };
    } else {
      giveawayForm = { title: '', description: '', prize: '', entry_type: 'any', requires_email: false, requires_phone: false, requires_telegram: false, start_date: '2026-11-01', end_date: '2026-12-01', max_participants: '', max_winner_entries: '1', num_winners: '1', status: 'draft' };
    }
    showGiveawayModal = true;
  }

  function closeGiveawayModal() { showGiveawayModal = false; editingGiveawayId = null; }

  async function drawGiveawayDialog(giveawayId: string) {
    const token = getToken();
    if (!token) return;
    const ok = confirm('¿Realmente sortear ganadores? Esta acción no se puede deshacer.');
    if (!ok) return;
    try {
      await api.drawGiveaway(token, giveawayId);
      addNotification('success', 'Sorteo realizado correctamente');
      await refreshGiveaways();
    } catch (e: any) { addNotification('error', e.message || 'Error al sortear'); }
  }

  function tabClass(t: string, tabKey: string) {
    return (activeTab === tabKey || (tabKey === 'giveaways' && activeTabGiveaways) || (tabKey === 'rewards' && activeTabRewards) || (tabKey === 'notifications' && activeTabNotifications))
      ? 'bg-energia-600 text-white border-b-2 border-energia-600'
      : 'bg-white text-gray-700 border-b-2 border-transparent hover:bg-gray-50';
  }
  function openServiceModal(item?: any) {
    editingServiceId = item?.id ?? null;
    serviceForm = item ? { ...item } : { name: '', slug: '', description: '', scope: '', price: '', price_type: 'quote', duration_minutes: '', is_active: true, sort_order: '0' };
    showServiceModal = true;
  }
  function closeServiceModal() { showServiceModal = false; editingServiceId = null; }
  function openCategoryModal(item?: any) {
    editingCategoryId = item?.id ?? null;
    categoryForm = item ? { ...item } : { name: '', slug: '', description: '', is_active: true, sort_order: '0' };
    showCategoryModal = true;
  }
  function closeCategoryModal() { showCategoryModal = false; editingCategoryId = null; }
  function openFAQModal(item?: any) {
    editingFAQId = item?.id ?? null;
    faqForm = item ? { ...item } : { question: '', answer: '', category_id: '', is_active: true, sort_order: '0' };
    showFAQModal = true;
  }
  function closeFAQModal() { showFAQModal = false; editingFAQId = null; }
  function openGalleryModal(item?: any) {
    editingGalleryId = item?.id ?? null;
    galleryForm = item ? { ...item } : { title: '', description: '', url: '', category: '', is_active: true, sort_order: '0' };
    showGalleryModal = true;
  }
  function closeGalleryModal() { showGalleryModal = false; editingGalleryId = null; }
  function openConfigModal(item?: any) {
    editingConfigId = item?.id ?? null;
    configForm = item ? { ...item } : { key: '', value: '', description: '' };
    showConfigModal = true;
  }
  function closeConfigModal() { showConfigModal = false; editingConfigId = null; }
  async function activateGiveaway(id: string) {
    const token = getToken();
    if (!token) return;
    try {
      await api.activateGiveaway(token, id);
      addNotification('success', 'Sorteo activado');
      await refreshGiveaways();
    } catch (e: any) { addNotification('error', e.message || 'Error al activar'); }
  }
  async function deactivateGiveaway(id: string) {
    const token = getToken();
    if (!token) return;
    try {
      await api.deactivateGiveaway(token, id);
      addNotification('success', 'Sorteo desactivado');
      await refreshGiveaways();
    } catch (e: any) { addNotification('error', e.message || 'Error al desactivar'); }
  }
  async function saveNotification() {
    const token = getToken();
    if (!token) return;
    try {
      if (notificationForm.customer_ids?.trim()) {
        const customer_ids = notificationForm.customer_ids.split(',').map((s: string) => s.trim()).filter(Boolean);
        await api.sendNotification(token, { customer_ids, title: notificationForm.title, message: notificationForm.message, type: notificationForm.type, data: notificationForm.data });
        addNotification('success', `Notificación enviada a ${customer_ids.length} cliente(s)`);
      } else {
        await api.broadcastNotification(token, { title: notificationForm.title, message: notificationForm.message, type: notificationForm.type, data: notificationForm.data });
        addNotification('success', 'Notificación enviada a todos los clientes');
      }
      closeNotificationModal();
      notificationForm = { customer_ids: '', type: 'system', title: '', message: '' };
      await refreshCustomerNotifications();
    } catch (e: any) { addNotification('error', e.message || 'Error enviando notificación'); }
  }
  function openNotificationModal() {
    notificationForm = { customer_ids: '', type: 'system', title: '', message: '' };
    showNotificationModal = true;
  }
  function closeNotificationModal() { showNotificationModal = false; }
</script>
<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
  {#if !showAdmin}
    <div class="bg-white border border-gray-200 rounded-xl p-8 md:p-12 shadow-sm max-w-md mx-auto">
      <h1 class="text-2xl font-bold text-gray-900 mb-6">Panel de Administración</h1>
      <form onsubmit={login} class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Correo electrónico</label>
          <input type="email" bind:value={email} required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-energia-500 outline-none" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
          <input type="password" bind:value={password} required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-energia-500 outline-none" />
        </div>
        <button type="submit" class="w-full bg-energia-600 text-white py-3 rounded-lg font-medium hover:bg-energia-700 transition-colors" disabled={loggingIn}>
          {loggingIn ? 'Iniciando sesión...' : 'Iniciar sesión'}
        </button>
      </form>
      <p class="mt-6 text-center text-sm text-gray-500">
        ¿Primera vez? Usa <code>/api/auth/setup</code> para crear el primer administrador.
      </p>
    </div>
  {:else}
    <!-- Tab Navigation -->
    <nav class="flex space-x-1 bg-white border border-gray-200 rounded-xl p-1 mb-6 overflow-x-auto">
      <button class="{tabClass('', 'dashboard')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={() => activeTab = 'dashboard'}>Dashboard</button>
      <button class="{tabClass('', 'products')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={() => activeTab = 'products'}>Productos</button>
      <button class="{tabClass('', 'services')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={() => activeTab = 'services'}>Servicios</button>
      <button class="{tabClass('', 'gallery')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={() => activeTab = 'gallery'}>Galería</button>
      <button class="{tabClass('', 'categories')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={() => activeTab = 'categories'}>Categorías</button>
      <button class="{tabClass('', 'faq')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={() => activeTab = 'faq'}>FAQ</button>
      <button class="{tabClass('', 'config')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={() => activeTab = 'config'}>Configuración</button>
      <button class="{tabClass('', 'giveaways')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={toggleGiveawaysTab}>Sorteos</button>
      <button class="{tabClass('', 'rewards')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={toggleRewardsTab}>Recompensas</button>
      <button class="{tabClass('', 'notifications')} px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap" onclick={toggleNotificationsTab}>Notificaciones</button>
    </nav>
    {#if activeTab === 'dashboard'}
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div class="bg-white border border-gray-200 rounded-xl p-6">
          <p class="text-sm text-gray-500 uppercase">Productos</p>
          <p class="text-2xl font-bold text-gray-900">{products.length}</p>
        </div>
        <div class="bg-white border border-gray-200 rounded-xl p-6">
          <p class="text-sm text-gray-500 uppercase">Servicios</p>
          <p class="text-2xl font-bold text-gray-900">{services.length}</p>
        </div>
        <div class="bg-white border border-gray-200 rounded-xl p-6">
          <p class="text-sm text-gray-500 uppercase">Galería</p>
          <p class="text-2xl font-bold text-gray-900">{gallery.length}</p>
        </div>
        <div class="bg-white border border-gray-200 rounded-xl p-6">
          <p class="text-sm text-gray-500 uppercase">Sorteos</p>
          <p class="text-2xl font-bold text-gray-900">{giveaways.length}</p>
        </div>
        <div class="bg-white border border-gray-200 rounded-xl p-6">
          <p class="text-sm text-gray-500 uppercase">Recompensas</p>
          <p class="text-2xl font-bold text-gray-900">{rewards.length}</p>
        </div>
        <div class="bg-white border border-gray-200 rounded-xl p-6">
          <p class="text-sm text-gray-500 uppercase">Notificaciones</p>
          <p class="text-2xl font-bold text-gray-900">{customerNotifications.length}</p>
        </div>
      </div>
    {/if}
    {#if activeTab === 'products'}
      <div class="flex justify-between items-end mb-4">
        <h2 class="text-lg font-bold text-gray-900">Gestión de productos</h2>
        <button class="bg-energia-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-energia-700 transition-colors" onclick={() => openProductModal()}>
          + Agregar producto
        </button>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Nombre</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Marca / Modelo</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Precio</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Estado</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {#each products as product}
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 text-gray-900 font-medium">{product.name}</td>
                  <td class="px-4 py-3 text-gray-600">{product.brand || '-'} {product.model || ''}</td>
                  <td class="px-4 py-3 text-gray-900">${product.price?.toLocaleString() || '-'} {product.currency}</td>
                  <td class="px-4 py-3">
                    <span class="px-2 py-1 rounded-full text-xs font-medium {product.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'} cursor-pointer" onclick={() => product.is_active = !product.is_active}>
                      {product.is_active ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <button class="text-energia-600 text-sm hover:underline mr-3" onclick={() => openProductModal(product)}>Editar</button>
                    <button class="text-red-600 text-sm hover:underline" onclick={() => confirmDelete('product', product.id)}>Eliminar</button>
                  </td>
                </tr>
              {:else}
                <tr>
                  <td colspan="5" class="px-4 py-8 text-center text-gray-500">No hay productos registrados.</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}
    {#if activeTab === 'services'}
      <div class="flex justify-between items-end mb-4">
        <h2 class="text-lg font-bold text-gray-900">Gestión de servicios</h2>
        <button class="bg-energia-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-energia-700 transition-colors" onclick={() => openServiceModal()}>
          + Agregar servicio
        </button>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Nombre</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Alcance</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Precio</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Tipo</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Estado</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {#each services as service}
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 text-gray-900 font-medium">{service.name}</td>
                  <td class="px-4 py-3 text-gray-600">{service.scope || '-'}</td>
                  <td class="px-4 py-3 text-gray-900">${service.price !== null && service.price !== undefined ? service.price.toLocaleString() : 'a consultar'}</td>
                  <td class="px-4 py-3 text-gray-600 text-sm">{service.price_type}</td>
                  <td class="px-4 py-3">
                    <span class="px-2 py-1 rounded-full text-xs font-medium {service.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'} cursor-pointer" onclick={() => service.is_active = !service.is_active}>
                      {service.is_active ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <button class="text-energia-600 text-sm hover:underline mr-3" onclick={() => openServiceModal(service)}>Editar</button>
                    <button class="text-red-600 text-sm hover:underline" onclick={() => confirmDelete('service', service.id)}>Eliminar</button>
                  </td>
                </tr>
              {:else}
                <tr>
                  <td colspan="6" class="px-4 py-8 text-center text-gray-500">No hay servicios registrados.</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}
    {#if activeTab === 'gallery'}
      <div class="flex justify-between items-end mb-4">
        <h2 class="text-lg font-bold text-gray-900">Gestión de galería</h2>
        <button class="bg-energia-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-energia-700 transition-colors" onclick={() => openGalleryModal()}>
          + Agregar imagen
        </button>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Título</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Descripción</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">URL</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Estado</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {#each gallery as item}
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 text-gray-900 font-medium">{item.title || '-'}</td>
                  <td class="px-4 py-3 text-gray-600">{item.description || ''}</td>
                  <td class="px-4 py-3 text-gray-600 text-xs">{item.url}</td>
                  <td class="px-4 py-3">
                    <span class="px-2 py-1 rounded-full text-xs font-medium {item.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}">
                      {item.is_active ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <button class="text-red-600 text-sm hover:underline" onclick={() => confirmDelete('gallery', item.id)}>Eliminar</button>
                  </td>
                </tr>
              {:else}
                <tr>
                  <td colspan="5" class="px-4 py-8 text-center text-gray-500">No hay imágenes en la galería.</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}
    {#if activeTab === 'categories'}
      <div class="flex justify-between items-end mb-4">
        <h2 class="text-lg font-bold text-gray-900">Gestión de categorías</h2>
        <button class="bg-energia-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-energia-700 transition-colors" onclick={() => openCategoryModal()}>
          + Agregar categoría
        </button>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Nombre</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Slug</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Estado</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {#each categories as cat}
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 text-gray-900 font-medium">{cat.name}</td>
                  <td class="px-4 py-3 text-gray-600">{cat.slug || '-'}</td>
                  <td class="px-4 py-3">
                    <span class="px-2 py-1 rounded-full text-xs font-medium {cat.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'} cursor-pointer" onclick={() => cat.is_active = !cat.is_active}>
                      {cat.is_active ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <button class="text-energia-600 text-sm hover:underline mr-3" onclick={() => openCategoryModal(cat)}>Editar</button>
                    <button class="text-red-600 text-sm hover:underline" onclick={() => confirmDelete('category', cat.id)}>Eliminar</button>
                  </td>
                </tr>
              {:else}
                <tr>
                  <td colspan="4" class="px-4 py-8 text-center text-gray-500">No hay categorías registradas.</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}

    {#if activeTab === 'faq'}
      <div class="flex justify-between items-end mb-4">
        <h2 class="text-lg font-bold text-gray-900">Gestión de FAQ</h2>
        <button class="bg-energia-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-energia-700 transition-colors" onclick={() => openFAQModal()}>
          + Agregar FAQ
        </button>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Pregunta</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Respuesta</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Estado</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {#each faqs as faq}
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 text-gray-900 font-medium">{faq.question}</td>
                  <td class="px-4 py-3 text-gray-600">{faq.answer?.slice(0, 80)}...</td>
                  <td class="px-4 py-3">
                    <span class="px-2 py-1 rounded-full text-xs font-medium {faq.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'} cursor-pointer" onclick={() => faq.is_active = !faq.is_active}>
                      {faq.is_active ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <button class="text-energia-600 text-sm hover:underline mr-3" onclick={() => openFAQModal(faq)}>Editar</button>
                    <button class="text-red-600 text-sm hover:underline" onclick={() => confirmDelete('faq', faq.id)}>Eliminar</button>
                  </td>
                </tr>
              {:else}
                <tr>
                  <td colspan="4" class="px-4 py-8 text-center text-gray-500">No hay FAQs registradas.</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}
    {#if activeTab === 'config'}
      <div class="flex justify-between items-end mb-4">
        <h2 class="text-lg font-bold text-gray-900">Configuración del Asistente</h2>
        <button class="bg-energia-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-energia-700 transition-colors" onclick={() => openConfigModal()}>
          + Agregar clave
        </button>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Clave</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Valor</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Descripción</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {#each configItems as cfg}
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 text-gray-900 font-medium">{cfg.key}</td>
                  <td class="px-4 py-3 text-gray-600">{cfg.value}</td>
                  <td class="px-4 py-3 text-gray-600 text-sm">{cfg.description || '-'}</td>
                  <td class="px-4 py-3">
                    <button class="text-energia-600 text-sm hover:underline mr-3" onclick={() => openConfigModal(cfg)}>Editar</button>
                    <button class="text-red-600 text-sm hover:underline" onclick={() => confirmDelete('config', cfg.id)}>Eliminar</button>
                  </td>
                </tr>
              {:else}
                <tr>
                  <td colspan="4" class="px-4 py-8 text-center text-gray-500">No hay configuración registrada.</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}
    {#if activeTab === 'giveaways'}
      <div class="flex justify-between items-end mb-4">
        <h2 class="text-lg font-bold text-gray-900">Gestión de sorteos</h2>
        <button class="bg-energia-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-energia-700 transition-colors" onclick={() => openGiveawayModal()}>
          + Agregar sorteo
        </button>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Título</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Premio</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Tipo de entrada</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Fecha inicio</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Fecha fin</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Participantes</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Estado</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {#each giveaways as g}
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 text-gray-900 font-medium">{g.title}</td>
                  <td class="px-4 py-3 text-gray-600">{g.prize || '-'}</td>
                  <td class="px-4 py-3 text-gray-600 text-sm">{g.entry_type}</td>
                  <td class="px-4 py-3 text-gray-600 text-sm">{g.start_date?.split('T')[0] || '-'}</td>
                  <td class="px-4 py-3 text-gray-600 text-sm">{g.end_date?.split('T')[0] || '-'}</td>
                  <td class="px-4 py-3 text-gray-600">{g.max_participants || '-'}</td>
                  <td class="px-4 py-3">
                    <span class="px-2 py-1 rounded-full text-xs font-medium {g.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}">
                      {g.status || (g.is_active ? 'Activo' : 'Inactivo')}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <button class="text-energia-600 text-sm hover:underline mr-3" onclick={() => openGiveawayModal(g)}>Editar</button>
                    {#if g.status === 'active' || g.is_active}
                    <button class="text-amber-600 text-sm hover:underline mr-3" onclick={() => deactivateGiveaway(g.id)}>Desactivar</button>
                    {:else}
                    <button class="text-green-600 text-sm hover:underline mr-3" onclick={() => activateGiveaway(g.id)}>Activar</button>
                    {/if}
                    <button class="text-blue-600 text-sm hover:underline mr-3" onclick={() => drawGiveawayDialog(g.id)}>Sortear</button>
                    <button class="text-red-600 text-sm hover:underline" onclick={() => confirmDelete('giveaway', g.id)}>Eliminar</button>
                  </td>
                </tr>
              {:else}
                <tr>
                  <td colspan="8" class="px-4 py-8 text-center text-gray-500">No hay sorteos registrados.</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}
    {#if activeTab === 'rewards'}
      <div class="flex justify-between items-end mb-4">
        <h2 class="text-lg font-bold text-gray-900">Gestión de recompensas</h2>
        <button class="bg-energia-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-energia-700 transition-colors" onclick={() => openRewardModal()}>
          + Agregar recompensa
        </button>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Nombre</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Descripción</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Costo</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Stock</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Estado</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {#each rewards as r}
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 text-gray-900 font-medium">{r.name}</td>
                  <td class="px-4 py-3 text-gray-600">{r.description || '-'}</td>
                  <td class="px-4 py-3 text-gray-900">${r.cost?.toLocaleString() || '-'}</td>
                  <td class="px-4 py-3 text-gray-600">{r.stock_quantity || 0}</td>
                  <td class="px-4 py-3">
                    <span class="px-2 py-1 rounded-full text-xs font-medium {r.is_active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}">
                      {r.is_active ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <button class="text-energia-600 text-sm hover:underline mr-3" onclick={() => openRewardModal(r)}>Editar</button>
                    <button class="text-red-600 text-sm hover:underline" onclick={() => confirmDelete('reward', r.id)}>Eliminar</button>
                  </td>
                </tr>
              {:else}
                <tr>
                  <td colspan="6" class="px-4 py-8 text-center text-gray-500">No hay recompensas registradas.</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}
    {#if activeTab === 'notifications'}
      <div class="flex justify-between items-end mb-4">
        <h2 class="text-lg font-bold text-gray-900">Notificaciones enviadas</h2>
        <button class="bg-energia-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-energia-700 transition-colors" onclick={openNotificationModal}>
          + Enviar notificación
        </button>
      </div>
      <div class="bg-white border border-gray-200 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-left">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Título</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Mensaje</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Tipo</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Destinatario</th>
                <th class="px-4 py-2 text-sm font-medium text-gray-600">Fecha</th>
              </tr>
            </thead>
            <tbody>
              {#each customerNotifications as n}
                <tr class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 text-gray-900 font-medium">{n.title || '-'}</td>
                  <td class="px-4 py-3 text-gray-600">{n.message?.slice(0, 60)}{n.message?.length > 60 ? '...' : ''}</td>
                  <td class="px-4 py-3 text-gray-600 text-sm">{n.type || '-'}</td>
                  <td class="px-4 py-3 text-gray-600 text-sm">{n.customer_id ? 'Cliente específico' : 'Todos los clientes'}</td>
                  <td class="px-4 py-3 text-gray-600 text-sm">{new Date(n.created_at).toLocaleDateString()}</td>
                </tr>
              {:else}
                <tr>
                  <td colspan="5" class="px-4 py-8 text-center text-gray-500">No hay notificaciones registradas.</td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      </div>
    {/if}

    {#if deletingType && deletingId}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4">
          <h3 class="text-lg font-bold text-gray-900 mb-4">¿Confirmar eliminación?</h3>
          <p class="text-gray-600 mb-6">Esta acción no se puede deshacer. ¿Estás seguro?</p>
          <div class="flex gap-4">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-300 transition-colors" onclick={() => { deletingType = null; deletingId = null; }}>Cancelar</button>
            <button class="flex-1 bg-red-600 text-white py-3 rounded-lg font-medium hover:bg-red-700 transition-colors" onclick={executeDelete}>Eliminar</button>
          </div>
        </div>
      </div>
    {/if}
    {#if showProductModal}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
          <h3 class="text-lg font-bold text-gray-900 mb-4">{editingProductId ? 'Editar producto' : 'Nuevo producto'}</h3>
          <div class="space-y-4">
            <div><label class="block text-sm font-medium text-gray-700">Nombre</label><input type="text" bind:value={productForm.name} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Slug</label><input type="text" bind:value={productForm.slug} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Marca</label><input type="text" bind:value={productForm.brand} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Modelo</label><input type="text" bind:value={productForm.model} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Precio</label><input type="number" bind:value={productForm.price} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Moneda</label>
              <select bind:value={productForm.currency} class="w-full px-3 py-2 border rounded-md">
                <option value="USD">USD</option><option value="EUR">EUR</option><option value="MXN">MXN</option>
              </select>
            </div>
            <div><label class="block text-sm font-medium text-gray-700">Descripción</label><textarea bind:value={productForm.description} class="w-full px-3 py-2 border rounded-md" rows="3"></textarea></div>
          </div>
          <div class="flex gap-4 mt-6">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300" onclick={closeProductModal}>Cancelar</button>
            <button class="flex-1 bg-energia-600 text-white py-3 rounded-lg hover:bg-energia-700" onclick={saveProduct}>Guardar</button>
          </div>
        </div>
      </div>
    {/if}

    {#if showServiceModal}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
          <h3 class="text-lg font-bold text-gray-900 mb-4">{editingServiceId ? 'Editar servicio' : 'Nuevo servicio'}</h3>
          <div class="space-y-4">
            <div><label class="block text-sm font-medium text-gray-700">Nombre</label><input type="text" bind:value={serviceForm.name} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Slug</label><input type="text" bind:value={serviceForm.slug} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Alcance</label><input type="text" bind:value={serviceForm.scope} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Precio</label><input type="number" bind:value={serviceForm.price} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Tipo</label>
              <select bind:value={serviceForm.price_type} class="w-full px-3 py-2 border rounded-md">
                <option value="quote">a consultar</option><option value="fixed">fijo</option>
              </select>
            </div>
            <div><label class="block text-sm font-medium text-gray-700">Descripción</label><textarea bind:value={serviceForm.description} class="w-full px-3 py-2 border rounded-md" rows="3"></textarea></div>
          </div>
          <div class="flex gap-4 mt-6">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300" onclick={closeServiceModal}>Cancelar</button>
            <button class="flex-1 bg-energia-600 text-white py-3 rounded-lg hover:bg-energia-700" onclick={saveService}>Guardar</button>
          </div>
        </div>
      </div>
    {/if}
    {#if showCategoryModal}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4">
          <h3 class="text-lg font-bold text-gray-900 mb-4">{editingCategoryId ? 'Editar categoría' : 'Nueva categoría'}</h3>
          <div class="space-y-4">
            <div><label class="block text-sm font-medium text-gray-700">Nombre</label><input type="text" bind:value={categoryForm.name} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Slug</label><input type="text" bind:value={categoryForm.slug} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Descripción</label><textarea bind:value={categoryForm.description} class="w-full px-3 py-2 border rounded-md" rows="3"></textarea></div>
          </div>
          <div class="flex gap-4 mt-6">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300" onclick={closeCategoryModal}>Cancelar</button>
            <button class="flex-1 bg-energia-600 text-white py-3 rounded-lg hover:bg-energia-700" onclick={saveCategory}>Guardar</button>
          </div>
        </div>
      </div>
    {/if}

    {#if showFAQModal}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
          <h3 class="text-lg font-bold text-gray-900 mb-4">{editingFAQId ? 'Editar FAQ' : 'Nueva FAQ'}</h3>
          <div class="space-y-4">
            <div><label class="block text-sm font-medium text-gray-700">Pregunta</label><input type="text" bind:value={faqForm.question} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Respuesta</label><textarea bind:value={faqForm.answer} class="w-full px-3 py-2 border rounded-md" rows="5"></textarea></div>
            <div><label class="block text-sm font-medium text-gray-700">Categoría</label><input type="text" bind:value={faqForm.category_id} class="w-full px-3 py-2 border rounded-md" /></div>
          </div>
          <div class="flex gap-4 mt-6">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300" onclick={closeFAQModal}>Cancelar</button>
            <button class="flex-1 bg-energia-600 text-white py-3 rounded-lg hover:bg-energia-700" onclick={saveFAQ}>Guardar</button>
          </div>
        </div>
      </div>
    {/if}

    {#if showGalleryModal}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4">
          <h3 class="text-lg font-bold text-gray-900 mb-4">Nueva imagen de galería</h3>
          <div class="space-y-4">
            <div><label class="block text-sm font-medium text-gray-700">Título</label><input type="text" bind:value={galleryForm.title} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">URL</label><input type="text" bind:value={galleryForm.url} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Descripción</label><textarea bind:value={galleryForm.description} class="w-full px-3 py-2 border rounded-md" rows="3"></textarea></div>
            <div><label class="block text-sm font-medium text-gray-700">Categoría</label><input type="text" bind:value={galleryForm.category} class="w-full px-3 py-2 border rounded-md" /></div>
          </div>
          <div class="flex gap-4 mt-6">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300" onclick={closeGalleryModal}>Cancelar</button>
            <button class="flex-1 bg-energia-600 text-white py-3 rounded-lg hover:bg-energia-700" onclick={saveGallery}>Guardar</button>
          </div>
        </div>
      </div>
    {/if}
  {#if showConfigModal}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4">
          <h3 class="text-lg font-bold text-gray-900 mb-4">{editingConfigId ? 'Editar configuración' : 'Nueva configuración'}</h3>
          <div class="space-y-4">
            <div><label class="block text-sm font-medium text-gray-700">Clave</label><input type="text" bind:value={configForm.key} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Valor</label><input type="text" bind:value={configForm.value} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Descripción</label><textarea bind:value={configForm.description} class="w-full px-3 py-2 border rounded-md" rows="3"></textarea></div>
          </div>
          <div class="flex gap-4 mt-6">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300" onclick={closeConfigModal}>Cancelar</button>
            <button class="flex-1 bg-energia-600 text-white py-3 rounded-lg hover:bg-energia-700" onclick={saveConfig}>Guardar</button>
          </div>
        </div>
      </div>
    {/if}
    {#if showGiveawayModal}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-lg w-full mx-4 max-h-[90vh] overflow-y-auto">
          <h3 class="text-lg font-bold text-gray-900 mb-4">{editingGiveawayId ? 'Editar sorteo' : 'Nuevo sorteo'}</h3>
          <div class="space-y-4">
            <div><label class="block text-sm font-medium text-gray-700">Título</label><input type="text" bind:value={giveawayForm.title} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Descripción</label><textarea bind:value={giveawayForm.description} class="w-full px-3 py-2 border rounded-md" rows="3"></textarea></div>
            <div><label class="block text-sm font-medium text-gray-700">Premio</label><input type="text" bind:value={giveawayForm.prize} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Tipo de entrada</label>
              <select bind:value={giveawayForm.entry_type} class="w-full px-3 py-2 border rounded-md">
                <option value="any">Cualquiera</option><option value="email">Email</option><option value="phone">Teléfono</option><option value="telegram">Telegram</option>
              </select>
            </div>
            <div class="flex gap-4">
              <label class="flex items-center"><input type="checkbox" bind:checked={giveawayForm.requires_email} class="mr-2" /> Email</label>
              <label class="flex items-center"><input type="checkbox" bind:checked={giveawayForm.requires_phone} class="mr-2" /> Teléfono</label>
              <label class="flex items-center"><input type="checkbox" bind:checked={giveawayForm.requires_telegram} class="mr-2" /> Telegram</label>
            </div>
            <div><label class="block text-sm font-medium text-gray-700">Fecha de inicio</label><input type="date" bind:value={giveawayForm.start_date} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Fecha de fin</label><input type="date" bind:value={giveawayForm.end_date} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Máximo de participantes</label><input type="number" bind:value={giveawayForm.max_participants} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Número de ganadores</label><input type="number" bind:value={giveawayForm.num_winners} class="w-full px-3 py-2 border rounded-md" /></div>
          </div>
          <div class="flex gap-4 mt-6">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300" onclick={closeGiveawayModal}>Cancelar</button>
            <button class="flex-1 bg-energia-600 text-white py-3 rounded-lg hover:bg-energia-700" onclick={saveGiveaway}>Guardar</button>
          </div>
        </div>
      </div>
    {/if}
    {#if showRewardModal}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4">
          <h3 class="text-lg font-bold text-gray-900 mb-4">{editingRewardId ? 'Editar recompensa' : 'Nueva recompensa'}</h3>
          <div class="space-y-4">
            <div><label class="block text-sm font-medium text-gray-700">Nombre</label><input type="text" bind:value={rewardForm.name} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Descripción</label><textarea bind:value={rewardForm.description} class="w-full px-3 py-2 border rounded-md" rows="3"></textarea></div>
            <div><label class="block text-sm font-medium text-gray-700">Costo</label><input type="number" bind:value={rewardForm.cost} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Cantidad en stock</label><input type="number" bind:value={rewardForm.stock_quantity} class="w-full px-3 py-2 border rounded-md" /></div>
          </div>
          <div class="flex gap-4 mt-6">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300" onclick={closeRewardModal}>Cancelar</button>
            <button class="flex-1 bg-energia-600 text-white py-3 rounded-lg hover:bg-energia-700" onclick={saveReward}>Guardar</button>
          </div>
        </div>
      </div>
    {/if}
    {#if showNotificationModal}
      <div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl p-6 max-w-md w-full mx-4">
          <h3 class="text-lg font-bold text-gray-900 mb-4">Enviar notificación</h3>
          <div class="space-y-4">
            <div><label class="block text-sm font-medium text-gray-700">Destinatarios (IDs separados por coma, deje vacío para todos)</label><input type="text" bind:value={notificationForm.customer_ids} class="w-full px-3 py-2 border rounded-md" placeholder="1, 2, 3..." /></div>
            <div><label class="block text-sm font-medium text-gray-700">Tipo</label>
              <select bind:value={notificationForm.type} class="w-full px-3 py-2 border rounded-md">
                <option value="system">Sistema</option><option value="promotion">Promoción</option><option value="alert">Alerta</option>
              </select>
            </div>
            <div><label class="block text-sm font-medium text-gray-700">Título</label><input type="text" bind:value={notificationForm.title} class="w-full px-3 py-2 border rounded-md" /></div>
            <div><label class="block text-sm font-medium text-gray-700">Mensaje</label><textarea bind:value={notificationForm.message} class="w-full px-3 py-2 border rounded-md" rows="4"></textarea></div>
          </div>
          <div class="flex gap-4 mt-6">
            <button class="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300" onclick={closeNotificationModal}>Cancelar</button>
            <button class="flex-1 bg-energia-600 text-white py-3 rounded-lg hover:bg-energia-700" onclick={saveNotification}>Enviar</button>
          </div>
        </div>
      </div>
    {/if}
  {/if}
</div>
